export default __webpack_public_path__ + "static/media/Organon_Logo_CMYK-with tag.98c432e4.jpg";